import classNames from 'clsx';
import { groupBy, isEmpty } from 'lodash';
import React, { useMemo } from 'react';

import type { CasinoIcon } from '@swf/casino';
import { CasinoGameTile } from '@swf/casino';
import type { CasinoGame } from '@swf/core/types/CasinoGame';
import type { CasinoRace } from '@swf/core/types/CasinoRaces';

import One from '../../assets/numbers/01.svg';
import Two from '../../assets/numbers/02.svg';
import Three from '../../assets/numbers/03.svg';
import Four from '../../assets/numbers/04.svg';
import Five from '../../assets/numbers/05.svg';
import Six from '../../assets/numbers/06.svg';
import Seven from '../../assets/numbers/07.svg';
import Eight from '../../assets/numbers/08.svg';
import Nine from '../../assets/numbers/09.svg';
import Ten from '../../assets/numbers/10.svg';

import styles from './NumberedGameTile.scss';

export interface Props {
  className?: string;
  count?: number;
  fsbLaunch?: boolean;
  game: CasinoGame;
  race?: CasinoRace;
  icon?: CasinoIcon;
  index?: number;
  noIconScale?: boolean;
  onLaunch?(game: CasinoGame): void;
  preload?: boolean;
  favouriteIcon?: JSX.Element;
  liveRaceIcon?: boolean;
}

const numbers = [One, Two, Three, Four, Five, Six, Seven, Eight, Nine, Ten];

const maximumNumberedTiles = numbers.length;

const NumberedGameTile: React.FC<Props> = ({
  className,
  count,
  fsbLaunch,
  game,
  race,
  icon,
  index = 0,
  noIconScale,
  onLaunch,
  preload,
  favouriteIcon,
  liveRaceIcon = true
}) => {
  const tables = useMemo(() => groupBy(game.tables, 'playType'), [game.tables]);

  return !isEmpty(tables) && index < maximumNumberedTiles ? (
    <div className={styles.container}>
      <div className={styles.number}>
        {React.createElement(numbers[index])}
        <span className={classNames(styles.numberShadow, index > 8 && styles.doubleDigit)} />
      </div>
      <div className={classNames(styles.iconContainer, className)}>
        <CasinoGameTile
          count={count}
          game={game}
          race={race}
          icon={icon}
          index={index}
          fsbLaunch={fsbLaunch}
          key={index}
          noIconScale={noIconScale}
          onLaunch={onLaunch}
          preload={preload}
          favouriteIcon={favouriteIcon}
          liveRaceIcon={liveRaceIcon}
        />
      </div>
    </div>
  ) : null;
};

export default NumberedGameTile;
